import {createSlice, PayloadAction} from '@reduxjs/toolkit';

export interface SearchStateChange {
    form: string;
    advancedSearch: boolean;
    search: Record<string, any> | string | null;
}

interface SearchState {
    advancedSearch: boolean;
    search: Record<string, any> | string | null;
}

interface SearchesState {
    searches: Record<string, SearchState>
}

const initialState: SearchesState = {
    searches: {}
};

const searchSlice = createSlice({
    initialState,
    name: 'search',
    reducers: {
        updateSearch: (state: SearchesState, action: PayloadAction<SearchStateChange>) => {
            state.searches[action.payload.form] = {
                advancedSearch: action.payload.advancedSearch,
                search: action.payload.search,
            }
        },
    },
});

export const {
    updateSearch,
} = searchSlice.actions;

export default searchSlice
